var PreferencesConstants = {
    DISPATCHER: "PREFERENCES_DISPATCHER",
    SET_ACTIVE_PREFERENCES: "SET_ACTIVE_PREFERENCES",
    SET_USER_SYSTEM_PREFERENCES: "SET_SYSTEM_USER_PREFERENCES"
};

export default PreferencesConstants;